var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"grid-center"},[_c('Person',{staticClass:"col-12 person"})],1),_vm._l((_vm.poolList),function(pool,key){return _c('div',{key:key,staticClass:"pool"},[_c('Pool',{attrs:{"pool":pool,"poolindex":key}})],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }